import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LANGS, type SupportedLang } from './detector';
import enCommon from './resources/en/common.json';
import zhTWCommon from './resources/zh-TW/common.json';
import zhCNCommon from './resources/zh-CN/common.json';
import jaCommon from './resources/ja/common.json';

export type FeatureResources = Partial<Record<SupportedLang, Record<string, unknown>>>;

export interface InitI18nOptions {
  defaultNamespace: 'portal' | 'console' | 'admin';
  appResources: FeatureResources;
  /** Extra namespaces, e.g. feature-scoped strings used via `useTranslation('login')`. */
  extraNamespaces?: Record<string, FeatureResources>;
}

export async function initI18n({ defaultNamespace, appResources, extraNamespaces = {} }: InitI18nOptions) {
  const extraNs = Object.keys(extraNamespaces);
  const buildLang = (lang: SupportedLang, common: Record<string, unknown>) => {
    const out: Record<string, Record<string, unknown>> = {
      common,
      [defaultNamespace]: appResources[lang] ?? {},
    };
    for (const ns of extraNs) out[ns] = extraNamespaces[ns]?.[lang] ?? {};
    return out;
  };

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      ns: ['common', defaultNamespace, ...extraNs],
      defaultNS: defaultNamespace,
      fallbackLng: 'en',
      supportedLngs: SUPPORTED_LANGS,
      resources: {
        en: buildLang('en', enCommon),
        'zh-TW': buildLang('zh-TW', zhTWCommon),
        'zh-CN': buildLang('zh-CN', zhCNCommon),
        ja: buildLang('ja', jaCommon),
      },
      detection: { order: ['cookie', 'navigator'], lookupCookie: 'sentinel_lang', caches: ['cookie'] },
      interpolation: { escapeValue: false },
    });
  return i18n;
}
